module.exports = {
    routes: {
        sbs: '/7big-secrets-to-180', 
        sways: '/7ways-to-improve-memory', 
        tvc: '/vitamin-checklist', 
        vfl: '/vitality-for-life-newsletter', 
        wyd: '/what-your-doctor-wasnt-taught',
        eo: '/explore',
        ds: '/explore',
        ob: '/guide-to-start-an-online-business'
    }
}